import { createSelector } from "reselect";
import { getLoadedShipment } from "./getLoadedShipment";

/**
 * Select the warehouse id of the loaded shipment
 */
export const selectLoadedShipmentWarehouseId = createSelector(
  getLoadedShipment,
  (loadedShipment) => loadedShipment?.warehouseId
);
